import { requests } from './api-service';

const notificationChannelApi = {
    getNotificationChannels: () => requests.get('notificationchannels'),
};


export default notificationChannelApi;